module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-thum"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "c-thum-row"
    }, [_c('div', {
      staticClass: "c-thum-item",
      class: (index + 1) % 2 === 0 ? 'even' : 'odd',
      on: {
        "click": function($event) {
          _vm.itemClick(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    }), _vm._v(" "), _vm._t("item", null, {
      obj: item
    })], 2)])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b6990fd","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-thum/index.vue
// module id = 1044
// module chunks = 2